const slick = require('slick-carousel');
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import PubSub from 'underpub-js';
import Equalizer from "../../../../scripts/classes/Equalizer";

var InsightsEventsHighlightSlider = function (options) {

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

InsightsEventsHighlightSlider.prototype.init = function () {

	let self = this;
	
	self.$imageSlider = self.options.$el.find(`.image-slider`);

	self.$imageSlider.slick({
		// speed: 350,
		// slidesToShow: 3,
		// infinite: true,
		arrows: false,
		dots: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 8000,
		asNavFor: '.content-slider',
	});

	self.$contentSlider = self.options.$el.find(`.content-slider`);

	self.$contentSlider.slick({
		// speed: 350,
		// slidesToShow: 3,
		// infinite: true,
		arrows: false,
		dots: false,
		fade: true,
		autoplay: true,
		autoplaySpeed: 8000,
		asNavFor: '.image-slider',
	});

	// set up equalizer to set height of slide counter container because children are position: absolute
	this.slideEq = new Equalizer( self.options.$el.find(`.content-slider .content-wrapper`) );
	this.slideEq.equalizeHeights();

	$(window).on('load', function() {
		self.slideEq.equalizeHeights();
	});

	PubSub.subscribe("resized", function(){
		self.slideEq = new Equalizer( self.options.$el.find(`.content-slider .content-wrapper`) );
		self.slideEq.equalizeHeights();
	});

	self.options.$el.find(`.dots-nav .dot`).on('click', function() {

		self.options.$el.find(`.dots-nav .dot`).removeClass('active');
		$(this).addClass('active');

		var slideNumber = $(this).data('slideNumber');

		self.$imageSlider.slick('slickGoTo', slideNumber - 1);

	});

	this.$imageSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {

		self.options.$el.find(`.dots-nav .dot`).removeClass('active');
		self.options.$el.find(`[data-slide-number="${nextSlide+1}"]`).addClass('active');

	});
	

};

export default InsightsEventsHighlightSlider;
